import React, { FC } from 'react';

import { Card, CardContent, Box, Divider, Grid, Link, Typography } from '@mui/material';

import LocationOnIcon from '@mui/icons-material/LocationOn';

import { BackflowJobGroup } from '../../model';

interface MailingAddressDisplayProps {
  backflowJobGroup: BackflowJobGroup;
}

const MailingAddressDisplay: FC<MailingAddressDisplayProps> = (props) => {
  const { backflowJobGroup } = props;

  if (!backflowJobGroup.authority_mailing_address) {
    return null;
  }

  return (
    <Card elevation={3}>
      <CardContent>
        <Grid item xs={12}>
          <Box display="flex" alignItems="center" mb={2}>
            <LocationOnIcon color="primary" sx={{ mr: 1 }} />
            <Typography variant="h6" fontWeight="600">
              Mailing Address
            </Typography>
          </Box>
          <Divider sx={{ mb: 1 }} />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" color="text.secondary">
            {backflowJobGroup.authority_mailing_address}
          </Typography>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default MailingAddressDisplay;
